//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, Checkbox, Chip, FormControl, FormHelperText, IconButton, InputLabel, ListItemText, MenuItem, Modal as ModalTest, OutlinedInput, Select } from '@mui/material';
//  -- Components ---------------------
import { Close, CloseOutlined } from '@mui/icons-material';
//  -- Features -----------------------
import { find, get, uniq } from 'lodash';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
//  -- Constants ----------------------
import { Col, Row, Spin } from 'antd';
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import { useBookmarks } from 'store/bookmark/selectors';

import { AddCircleSharp, ArrowBackIos, RemoveCircle } from '@mui/icons-material';
import { Snackbar } from '@mui/material';

import { Alert } from '@mui/material';
import { Modal as ModalDrop } from 'antd';
import { handleAutologinOneGame, handleBookContent, handleSyncBookCategories } from "store/one_game/thunks";
import { AiGeneratedBook, AiGeneratedTopic, CreateFlashCardIcon, CreateQuizIcon, DebateLftIcon, IGameAI, IGameLogo, IGameModalImgDeck, IGameRightTick, studyBlankTemplate } from "utils/assets/images";
import OneStudyIcon from "../../utils/assets/images/OneStudyIcon.svg";


import { Drawer } from 'antd';

import { useOneGameModal } from 'store/one_game/selectors';
import { useUserClasses } from 'store/userClasses/selectors';
import AdminStudy from './AdminStudy';
import DraftStudy from './DraftStudy';
import MyStudy from './MyStudy';
import StudentStudy from './StudentStudy';
import AllTeachersStudy from './AllTeachersStudy';

import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import DemoPreview from 'components/ViewDemoModal';

import RenderIfVisible from 'react-render-if-visible';
import { makeStyles } from '@mui/styles';
import { useBookOrder } from 'store/books/selectors';
import sysConfig from "config"
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { getBookDisplayName, getUnitsPages, isVideo } from 'utils/lib/ebookHelper';
import { useResources, useVideos } from 'store/resources/selectors';
import { useUserProfileConfig } from 'store/users/selectors';
import { Badge } from '@mui/material';
import { useLearningModuleCount } from 'store/bingo/selectors';
import SentryWrap from 'components/Sentry';
const ButtonContainers = styled.div`
   display: flex !important;
   align-items:center;
    flex-wrap:wrap;
    gap:11px;
`;

const ModalContentDelete = styled.div`
  align-items: center;
  background-color: #112643;
//   display: inline-flex;
  flex-direction: column;
  left: 50%;
  width: 83%;
 padding: 30px 0px 0px 0px;
  position: absolute;
//   text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  
  @media (max-width: 767px) {
    width: 92%; 
  }
  `;


const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));

//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook
//
//  -- Description
//  Ebook display component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const configServer = import.meta.env.VITE_APP_STAGE?.trim() === 'prod'
    ? 'prod'
    : 'dev';

const OnestudyModals = ({
    chapter,
    page,
    newMaskId,
    currentUser,
    booksAllList,
    currentClass,
    aiModal,
    setAiModal,
    page_1game_ai_content,
    oneStudyModal = () => null,
    resource = false,
    backToLabelStory = false,
    pages = [],
    bookUnits = {},
    book_content = {},
    studyCardId = null,
    // pageLearningModuleCountStudy = {}
}) => {
    const videos = useVideos();
    const showAlert = useAlert();
    const inputRef = useRef(null);
    const dispatch = useDispatch();
    const resources = useResources();
    const classBookmark = useBookmarks();
    const userClasses = useUserClasses();
    const classes = useStyles();
    const { openOnegameModal } = useOneGameModal();
    const learningModuleCount = useLearningModuleCount();
    const [modalVisible, setModalVisible] = useState(false);
    const [currentSection, setCurrentSection] = useState(1);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectStudyValue, setSelectStudyValue] = useState('');
    const [gameVisibleEbk, setgameVisibleEbk] = useState(false);
    const [currentScenarioEbk, setCurrentScenarioEbk] = useState(1);
    const [selected, setSelected] = useState(false);
    const [selectedAdd, setSelectedAdd] = useState(false);
    const [redirectLoader, setRedirectLoader] = useState(false);
    const [visible, setVisible] = useState(false);
    const [activeGame, setActiveGame] = useState({});
    const getNumberMask = useCallback((_page) => get(find(get(find(booksAllList, { id: chapter }), "pages"), k => k.pageId == _page), "NumberMasked", _page), [chapter, booksAllList, classBookmark])
    const getBookDataForGame = useMemo(() => find(booksAllList, { id: chapter }), [booksAllList, chapter]);
    const [gameInitLoader, setGameInitLoader] = useState(false);
    const [gameEditLoader, setGameEditLoader] = useState(false);
    const [gameRedirectLoader, setGameRedirectLoader] = useState(false);
    const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })
    const [oneStudyType, setOneStudyType] = useState('all');
    const [studyType, setStudyType] = useState('');
    const [gameDuplicateLoader, setGameDuplicateLoader] = useState(false);
    const bookOrder = useBookOrder()
    const { isAiPermissionEnabled } = useUserProfileConfig();

    const [error, setError] = useState(false);
    const [createConfigModal, setOpenCreateConfigModal] = useState(false);

    const [config, setConfig] = useState({ pages:'' });
    const [createLoader, setCreateLoader] = useState(false);

    const currentPage = Number(page);
    // const rangeStart = Math.max(currentPage - 4, 1);
    // const rangeEnd = currentPage + 4;
    // const pagesToCheck = Array.from({ length: rangeEnd - rangeStart + 1 }, (_, i) => (rangeStart + i).toString());

    const isTeacher = get(currentUser, "role") === "teacher";
    const isAdmin = get(currentUser, "role") === "owe_admin";
    const {checkPopUpAtOnce, updatePopUpAtOnce} = usePopUpAtOnce();

    const pageLearningModuleCountStudy = useMemo(() => {
            return learningModuleCount?.study;
    }, [learningModuleCount, newMaskId, studyCardId]);

    const pageLearningModuleCountQuiz = useMemo(() => {
        return learningModuleCount?.study?.filter(item => item?.study_metadata?.type === 'quiz')?.length;
    }, [learningModuleCount]);

    const pageLearningModuleCountFlashCard = useMemo(() => {
        return learningModuleCount?.study?.filter(item => item?.study_metadata?.type === 'flash_card')?.length;
    }, [learningModuleCount]);

    const pageLearningModuleCountStudyAdmin = useMemo(() => {
        return learningModuleCount?.adminStudy;
    }, [learningModuleCount, newMaskId, studyCardId]);

    const handleButtonClick = () => {
        setSelected(true);
    };
    const handleAddButtonClick = () => {
        setSelectedAdd(true);
    }

    const handleCancelEbk = () => {
        setgameVisibleEbk(false);
    };
    const handleNextEbk = () => {
        setCurrentScenarioEbk(currentScenarioEbk + 1);
    };
    const showModalEbk = () => {    
        setgameVisibleEbk(true);
        setCurrentScenarioEbk(2);
    };
    const handleFlashcard = (game_type) => {
        setStudyType(game_type)
        setgameVisibleEbk(true);
        setCurrentScenarioEbk(1);
    }

    const onAIPagesClose = () => {
        if (createLoader) return
        setOpenCreateConfigModal(false);
        setConfig({ pages: '' })
    }

    const onAIContentPageModal = () => {
        setOpenCreateConfigModal(true)
        setConfig(k => ({ ...k, pages: `${page}` }));
    }

    const handleCancel = () => {
        setModalVisible(false);
        setAiModal(false)
        updatePopUpAtOnce(false);
    };

    const showModal = (type) => {
        setModalVisible(true);
        setCurrentSection(type ? type : 1);
        if (type === 'all_teachers') {
            setSelectedValue('all');
            setOneStudyType('all');
        }
    };

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };
    const getBooks = () => {
        const books = [];
        (currentClass.books_group || []).forEach((key) => {
            bookOrder.forEach((order) => {
                if (order.key === key) {
                    books.push(...order.order);
                }
            })
        })
        return uniq(books);
    }
    const getClassMetadata = () => {
        return ({
            class_id: currentClass.id,
            class_display_name: currentClass.displayName,
            books: getBooks(),
            classes: userClasses.map(({ books, displayName, id }) => ({
                books,
                displayName,
                id,
            }))
        })
    }
    const contentInfo = (data) => {
      const bookName = getBookDisplayName(booksAllList, chapter, true, videos, resources);
      const end = getNumberMask(data?.end_page || "");
      const start = getNumberMask(data?.start_page || "");
      const pageInfo = start || end ? `${start} - ${end}` : "";
      return `${bookName}${pageInfo ? `  ${pageInfo}` : ""}`;
    };

    const onAiContentCreation = async() => {
        const pages = get(getBookDataForGame, "pages", []);
        const unitsPages = getUnitsPages(page, bookUnits, pages);
        const hasSuperLessonPage = getBookDataForGame?.superLesson
          ? find(getBookDataForGame.superLesson, (p) => {
              const from = Number(p.from);
              const to = Number(p.to);
              const currentPageIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === Number(page));
              const startIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === from);
              const endIndex = pages.findIndex((x) => parseInt(x.pageId, 10) === to);
              return currentPageIndex >= startIndex && currentPageIndex <= endIndex;
            })
          : null;
        let content = {
            content: '',
            contentInfo: ''
        }
        if (!page_1game_ai_content) {
            content = {
                content: '',
                contentInfo: contentInfo(page_1game_ai_content)
            }
        } else {
            content = {
                content: "",
                contentInfo: contentInfo(page_1game_ai_content)
            }
        }
        setRedirectLoader(content ? "ai_content" : 'ai')
        setCreateLoader(true);
        let allPages = [];
        if(Array.isArray(book_content)&&book_content.length > 0){
            allPages = book_content.map((x) => parseInt(x.pageId, 10)).slice(0,15);
          }
        else if (isAdmin) {
          allPages = config?.pages.split(',').map((p) => parseInt(p.trim(), 10));
        } else if (hasSuperLessonPage) {
            const from = parseInt(hasSuperLessonPage.from, 10);
            const to = parseInt(hasSuperLessonPage.to, 10);
            if(getBookDataForGame?.pages?.length > 0){
              const startIndex = getBookDataForGame?.pages?.findIndex((x) => parseInt(x.pageId, 10) === from);
              const endIndex = getBookDataForGame?.pages?.findIndex((x) => parseInt(x.pageId, 10) === to);
              allPages = getBookDataForGame?.pages?.slice(startIndex, endIndex + 1).map((x) => parseInt(x.pageId, 10));
            }
          } else if (unitsPages.unit?.id) {
            allPages =  unitsPages.pagesInRange.map((x) => parseInt(x.pageId, 10));
          } else {
          allPages = [currentPage];
        }
        const result = await dispatch(handleBookContent({ chapter, page: allPages, resource }))
        const hasAnyContent = resource ? result !== '' : Array.isArray(result) && result.some(item => Array.isArray(item?.content) && item.content.length > 0);
        if (!hasAnyContent) {
            setRedirectLoader(null);
            setCreateLoader(false);
            return showAlert('This page has no content. Please select a page with content on it', "info")
        }
        await handleRedirectOnegame('ai', content, null, allPages)
        setCreateLoader(false);
        setOpenCreateConfigModal(false);
    }

    const handleAIGenerateFromMyOwnTopics = () => {
        if (!isAiPermissionEnabled) {
            showAlert('Please enable AI permission to generate content using AI.', 'error');
            return;
        }
        handleRedirectOnegame("ai")
    }
    const handleRedirectOnegame = async (templet, content, Type, allPages) => {
        setRedirectLoader(content ? "ai_content" : templet)
        const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, 
            { 
                pages: (content && isAdmin && config?.pages) ? config.pages.split(',') :  allPages?.length > 0
                ? allPages.map(p => String(p)) : [],
                user_role_admin: isAdmin, 
                action: 'create_game', 
                templet: templet, 
                bookId: chapter, 
                page: page, 
                pageTitle: getNumberMask(page) || page, 
                content, 
                categoryImage: getBookDataForGame?.resource, 
                categoryTitle: getBookDataForGame?.description, 
                class_info: getClassMetadata(), 
                study_metadata: { type: Type ? Type : studyType }, 
                game_type: '1study',
                resource,
                isAiPermissionEnabled
            }
        ));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth'
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
            //  window.open(url, '_blank');
        }
        setgameVisibleEbk(false);
        setRedirectLoader(null)
    }

    const closeAlert = () => {
        setAlertSakeBar({ ...alertSakeBar, open: false, message: '' })
    }
    const handleChange = (value) => {
        if (get(currentUser, "role") === "teacher") {
            if (value == '1') {
                showModal(1);
            }
            else if (value == 'my_game') {
                showModal('my_game')
            }
            else if (value == 'all_teachers') {
                showModal('all_teachers')
            }
            else if (value == 'Game_Homepage') {
                onRedirect1Study();
            }
            else if (value == 'draft_game') {
                showModal('draft_game')
            }
            else {
                showModalEbk();
                handleCancel();
            }
        }
    };

    const onGameEdit = async (gameData) => {
        setGameEditLoader(gameData.game_id);
        const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, { user_role_admin: isAdmin, action: 'edit_game', role: 'teacher', game_id: gameData.game_id, class_info: getClassMetadata(), study_metadata: gameData?.study_metadata, game_type: '1study', isAiPermissionEnabled }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth'
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameEditLoader(null);
        handleCancel();
    }

    const onStartGame = async (gameData) => {
        let uri = `https://1gamestaging.nosotrosonline.com/1studyplay?game_id=${gameData?.game_id}&type=nosotros`
        if (sysConfig.is_local) {
            uri = `http://${window.location.hostname}:3011/1studyplay?game_id=${gameData?.game_id}&type=nosotros`
        } else if (configServer === 'prod') {
            uri = `https://1game.nosotrosonline.com/1studyplay?game_id=${gameData?.game_id}&type=nosotros`
        }
        openOnegameModal(uri);
        handleCancel();
    }
    const onGameDuplicate = async (gameData) => {
        setGameDuplicateLoader(gameData.game_id)
        const data = await dispatch(handleAutologinOneGame(currentUser.id, currentClass.id, { user_role_admin: isAdmin, action: 'duplicate_game', role: 'teacher', game_id: gameData.game_id, class_info: getClassMetadata(), isAiPermissionEnabled }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth'
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameDuplicateLoader(null)
        handleCancel();
    }

    const handleSubFilter = (value) => {
        setSelectedValue(value)
        if (value === 'all') {
            setOneStudyType('all')
        } else if (value === 'quiz') {
            setOneStudyType('quiz');
        } else if (value === 'flash_card') {
            setOneStudyType('flash_card');
        }
    }

    const handleMyStudyFilter = (value) => {
        setSelectStudyValue(value)
        if (value === 'all') {
            setOneStudyType('all')
        } else if (value === 'quiz') {
            setOneStudyType('quiz');
        } else if (value === 'flash_card') {
            setOneStudyType('flash_card');
        }
    }

    const user_type = useMemo(() => {
        const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
        const isCleverUser = !!(currentUser && currentUser.cleverId);
        const isCanvasUser = !!(currentUser && currentUser.canvas_id);
        const isGoogleUser = !!(currentUser && currentUser.googleId);
        const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
        if (isSchoologyUser) {
            return 'schoology'
        } else if (isCleverUser) {
            return 'clever'
        }
        else if (isCanvasUser) {
            return 'canvas'
        }
        else if (isClassLinkuser) {
            return 'classlink'
        }
        else if (isGoogleUser) {
            return 'google'
        }
        else {
            return 'owe'
        }
    }, [currentUser])

    const handleAIGenerateFromBookSection = () => {
        if(!isAiPermissionEnabled){
            showAlert('Please enable AI permission to generate content using AI.', 'error');
            return;
        }
        if(isAdmin && !isVideo(chapter, resources)) {
            onAIContentPageModal();
        } else {
            onAiContentCreation();
        }
    }
    const onRedirect1Study = async () => {
        setGameRedirectLoader(true)
        const data = await dispatch(handleAutologinOneGame(currentUser.id,
            currentClass.id,
            {
                user_role_admin: isAdmin,
                action: 'home_study',
                role: 'teacher',
                class_info: getClassMetadata(),
                user_type,
                // grade_category,
                isAiPermissionEnabled,
                // grade_type
            }));
        dispatch(handleSyncBookCategories(currentUser.id))
        if (data && data.key) {
            let uri = `https://1gamestaging.nosotrosonline.com/session_auth`
            if (sysConfig.is_local) {
                uri = `http://${window.location.hostname}:3011/session_auth`
            } else if (configServer === 'prod') {
                uri = 'https://1game.nosotrosonline.com/session_auth'
            }
            const url = `${uri}?key=${data.key}`
            openOnegameModal(url);
        }
        setGameRedirectLoader(false)
        handleCancel()
    }

    const handleForDistrictAdmin = () =>{
        if (currentUser.role === 'admin') {
          showAlert('Please login as teacher!' ,"error")
          return true;
        }
        return false;
      }

    return (
        <SentryWrap>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={closeAlert}>
                <Alert onClose={() => { setAlertSakeBar({ open: false, message: '' }) }} severity={alertSakeBar.severity}>
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>

            <ModalTest
                open={aiModal || modalVisible}
                onClose={() => handleCancel()}
                closeIcon={<CloseOutlined />}
            >
                <ModalContentDelete style={{ position: 'relative' }}>
                    <IconButton
                        onClick={() => handleCancel()}
                        style={{ position: 'absolute', top: 0, right: 0 }}>
                        <Close color="secondary" />
                    </IconButton>
                    <div style={{overflowY:'auto',maxHeight:'85vh',overflowX:'hidden'}}>
                        {(isTeacher || isAdmin) && (
                            <div className='createBtnGame'>
                                <ButtonContainers className='btnGameGrpPadding15 2222'>
                                    {!isAdmin && (
                                    <Badge
                                    overlap="rectangular"
                                    badgeContent={pageLearningModuleCountStudyAdmin?.length > 0 ? pageLearningModuleCountStudyAdmin?.length : undefined}
                                    // badgeContent={'0'}
                                    color="info"
                                    variant="standard"
                                    >
                                    <Button
                                        variant="outlined"
                                        color={"primary"}
                                        onClick={() => {
                                            showModal(1);
                                            setOneStudyType('all');
                                            setSelectedValue('all');
                                        }}
                                        className={`BtnSelectedoneGame ${currentSection === 1 ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneGameFocus"}`}
                                    >
                                        One Way Created
                                    </Button>
                                    </Badge>
                                    )}
                                    <Badge
                                    overlap="rectangular"
                                    // badgeContent={pageLearningModuleCount?.bingo_admin > 0 ? pageLearningModuleCount?.bingo_admin : '0'}
                                    badgeContent={pageLearningModuleCountStudy?.length > 0 ? pageLearningModuleCountStudy?.length : undefined}
                                    color="info"
                                    variant="standard"
                                    >
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            showModal('my_game');
                                            setOneStudyType('all');
                                            setSelectStudyValue('all')
                                        }}

                                        className={`BtnSelectedoneGame ${currentSection === "my_game" ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneGameFocus"}`}
                                    >My 1Study's
                                    </Button>
                                    </Badge>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            showModalEbk()
                                            handleCancel();
                                        }}
                                        className={`BtnSelectedoneGame ${currentSection === "3" ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneGameFocus"}`}
                                    >Create 1Study</Button>
                                    {/* <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            onRedirect1Study();
                                        }}
                                        className={`BtnSelectedoneGame ${currentSection === "1Game" ? "BtnSelectedoneGameFocus" : ""}`}
                                    >
                                        {gameRedirectLoader ? <Loading size={12} white /> : null} 1Study Homepage
                                    </Button> */}
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => { showModal('all_teachers') }}
                                        className={`BtnSelectedoneGame ${currentSection === "all_teachers" ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneGameFocus"}`}
                                    >Teachers Created</Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            showModal('draft_game');
                                        }}
                                        className={`BtnSelectedoneGame ${currentSection === "draft_game" ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneGameFocus"}`}
                                    >Draft</Button>
                                    {currentSection === 1 && (
                                        <div>
                                            <div className='studyDropDwnCard'>

                                                <select value={selectedValue} onChange={(e) => {
                                                    handleSubFilter(e.target?.value)
                                                }}>
                                                    <option
                                                        value={'all'}
                                                        variant="outlined"
                                                        color={"primary"}
                                                        onClick={() => { setOneStudyType('all') }}
                                                        className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        All
                                                    </option>
                                                    <option
                                                        value={'quiz'}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            
                                                            // setOneStudyType('quiz')
                                                        }}

                                                        className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Quiz
                                                    </option>
                                                    <option
                                                        value={'flash_card'}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            setOneStudyType('flash_card')
                                                        }}
                                                        className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Flashcard
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    {currentSection === "my_game" && (
                                        <div>

                                            <div className='studyDropDwnCard'>

                                                <select value={selectStudyValue} onChange={(e) => { handleMyStudyFilter(e.target?.value) }}>
                                                    <option
                                                        value={'all'}
                                                        variant="outlined"
                                                        color={"primary"}
                                                        className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        All
                                                    </option>
                                                    <option
                                                        value={'quiz'}
                                                        variant="outlined"
                                                        color="primary"
                                                        className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Quiz
                                                    </option>
                                                    <option
                                                        value={'flash_card'}
                                                        variant="outlined"
                                                        color="primary"
                                                        className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Flashcard
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    {currentSection === "all_teachers" && (
                                        <div>
                                            <div className='studyDropDwnCard'>
                                                <select value={selectedValue} onChange={(e) => {
                                                    handleSubFilter(e.target?.value)
                                                }}>
                                                    <option
                                                        value={'all'}
                                                        variant="outlined"
                                                        color={"primary"}
                                                        onClick={() => { setOneStudyType('all') }}
                                                        className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        All
                                                    </option>
                                                    <option
                                                        value={'quiz'}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            setOneStudyType('quiz')
                                                        }}
                                                        className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Quiz
                                                    </option>
                                                    <option
                                                        value={'flash_card'}
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => {
                                                            setOneStudyType('flash_card')
                                                        }}
                                                        className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                    >
                                                        Flashcard
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                     <DemoPreview video_id={"1study-demo"} wrapperStyle={{}} />
                                </ButtonContainers>
                            </div>
                        )}
                        {get(currentUser, "role") === "student" && (
                            <div className='createBtnGame'>
                                <ButtonContainers className='btnGameGrp' style={{ marginTop: 10 }}>
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={pageLearningModuleCountStudy?.length > 0 ? pageLearningModuleCountStudy?.length : undefined}
                                        color="info"
                                        variant="standard"
                                    >                   
                                        <Button
                                            variant="outlined"
                                            color={"primary"}
                                            onClick={() => { setOneStudyType('all') }}
                                            className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                        >
                                            All
                                        </Button>
                                    </Badge>
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={pageLearningModuleCountQuiz > 0 ? pageLearningModuleCountQuiz : undefined}
                                        color="info"
                                        variant="standard"
                                    >
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => { setOneStudyType('quiz') }}
    
                                            className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                        >
                                            Quiz
                                        </Button>
                                    </Badge>
                                    <Badge
                                        overlap="rectangular"
                                        badgeContent={pageLearningModuleCountFlashCard > 0 ? pageLearningModuleCountFlashCard : undefined}
                                        color="info"
                                        variant="standard"
                                    >
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                setOneStudyType('flash_card')
                                            }}
                                            className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                        >
                                            Flashcard
                                        </Button>
                                    </Badge>
                                </ButtonContainers>
                            </div>
                        )}
                        {(isTeacher || isAdmin) && (
                            <div style={{marginLeft:"16px", marginRight:"16px"}}>
                                <div className='mb-8 showInMobile'>
                                    <Select
                                        labelId="simple-select-label"
                                        id="simple-select"
                                        style={{ backgroundColor: 'white', width: '100%', borderRadius: 8, padding: '5px 12px', marginTop: 15 }}
                                        onChange={(e) => {
                                            handleChange(e.target.value);
                                        }}
                                        value={currentSection}

                                    >
                                        {!isAdmin && (
                                        <MenuItem value="1"
                                            variant="outlined"
                                            color={"primary"}
                                            onClick={() => {
                                                showModal(1);
                                                setOneStudyType('all');
                                                setSelectedValue('all');
                                            }}
                                            className={`BtnSelectedoneGame ${currentSection === 1 ? "" : ""}`}
                                        >One Way Created</MenuItem>
                                        )}
                                        <MenuItem value="my_game"
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                showModal('my_game');
                                                setOneStudyType('all');
                                                setSelectStudyValue('all')
                                            }}
                                            className={`BtnSelectedoneGame ${currentSection === "my_game" ? "" : ""}`}
                                        >My 1Study's</MenuItem>
                                        <MenuItem value="Create 1games">Create 1Study</MenuItem>
                                        {/* <MenuItem value="Game_Homepage"> 1Study Homepage</MenuItem> */}
                                        <MenuItem value="all_teachers"
                                            variant="outlined"
                                            color="primary"
                                            className={`BtnSelectedoneGame ${currentSection === "all_teachers" ? "" : ""}`}
                                        >Teachers Created</MenuItem>
                                        <MenuItem value="draft_game"
                                            variant="outlined"
                                            color={"primary"}
                                            className={`BtnSelectedoneGame ${currentSection === "draft_game" ? "" : ""}`}
                                        >Draft</MenuItem>
                                    </Select>
                                </div>
                                <div className='mobileStudyFilterSec'>
                                    <>
                                        {currentSection === 1 && (
                                            <div className="previwMobile">
                                                <div className='studyDropDwnCard studyMobileDropDwn'>

                                                    <select value={selectedValue} onChange={(e) => {
                                                        handleSubFilter(e.target?.value)
                                                    }}>
                                                        <option
                                                            value={'all'}
                                                            variant="outlined"
                                                            color={"primary"}
                                                            onClick={() => { setOneStudyType('all') }}
                                                            className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            All
                                                        </option>
                                                        <option
                                                            value={'quiz'}
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => {
                                                              
                                                                // setOneStudyType('quiz')
                                                            }}

                                                            className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Quiz
                                                        </option>
                                                        <option
                                                            value={'flash_card'}
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => {
                                                                setOneStudyType('flash_card')
                                                            }}
                                                            className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Flashcard
                                                        </option>
                                                    </select>
                                                </div>
                                                <DemoPreview video_id={"1study-demo"} wrapperStyle={{}} style={{marginTop:"10px", marginLeft:"10px"}} />
                                            </div>
                                        )}
                                    </>
                                    <>
                                        {currentSection === "my_game" && (
                                            <div className="previwMobile">
                                                <div className='studyDropDwnCard studyMobileDropDwn'>
                                                    <select value={selectStudyValue} onChange={(e) => { handleMyStudyFilter(e.target?.value) }}>
                                                        <option
                                                            value={'all'}
                                                            variant="outlined"
                                                            color={"primary"}
                                                            className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            All
                                                        </option>
                                                        <option
                                                            value={'quiz'}
                                                            variant="outlined"
                                                            color="primary"
                                                            className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Quiz
                                                        </option>
                                                        <option
                                                            value={'flash_card'}
                                                            variant="outlined"
                                                            color="primary"
                                                            className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Flashcard
                                                        </option>
                                                    </select>
                                                </div>
                                                <DemoPreview video_id={"1study-demo"} wrapperStyle={{}} />
                                            </div>
                                        )}
                                        {currentSection === "all_teachers" && (
                                            <div className="previwMobile">
                                                <div className='studyDropDwnCard studyMobileDropDwn'>
                                                    <select value={selectedValue} onChange={(e) => {
                                                        handleSubFilter(e.target?.value)
                                                    }}>
                                                        <option
                                                            value={'all'}
                                                            variant="outlined"
                                                            color={"primary"}
                                                            onClick={() => { setOneStudyType('all') }}
                                                            className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            All
                                                        </option>
                                                        <option
                                                            value={'quiz'}
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => {
                                                                setOneStudyType('quiz')
                                                            }}
                                                            className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Quiz
                                                        </option>
                                                        <option
                                                            value={'flash_card'}
                                                            variant="outlined"
                                                            color="primary"
                                                            onClick={() => {
                                                                setOneStudyType('flash_card')
                                                            }}
                                                            className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "BtnSelectedoneGameFocus" : ""}`}
                                                        >
                                                            Flashcard
                                                        </option>
                                                    </select>
                                                </div>
                                                <DemoPreview video_id={"1study-demo"} wrapperStyle={{}} />
                                            </div>
                                        )}
                                    </>
                                </div>
                            </div>
                        )}

                        {get(currentUser, "role") === "student" && (
                            <div>
                                <div className='mb-8 showInMobile'>
                                    <Select
                                        labelId="simple-select-label"
                                        id="simple-select"
                                        style={{ backgroundColor: 'white', width: '100%', borderRadius: 8, padding: '5px 12px', marginTop: 15 }}
                                        onChange={(e) => {
                                            handleChange(e.target.value)
                                        }}
                                        defaultValue={"all"}

                                    >
                                        <MenuItem
                                            value="all"
                                            variant="outlined"
                                            color={"primary"}
                                            onClick={() => {
                                                setOneStudyType('all')
                                            }}
                                            className={`BtnSelectedoneGame ${oneStudyType === 'all' ? "" : ""}`}
                                        >All</MenuItem>
                                        <MenuItem
                                            value="quiz"
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => { setOneStudyType('quiz') }}
                                            className={`BtnSelectedoneGame ${oneStudyType === "quiz" ? "" : ""}`}
                                        >Quiz</MenuItem>
                                        <MenuItem
                                            value="flash_card"
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                setOneStudyType('flash_card')
                                            }}
                                            className={`BtnSelectedoneGame ${oneStudyType === "flash_card" ? "" : ""}`}

                                        >Flashcard</MenuItem>

                                    </Select>
                                </div>
                            </div>
                        )}


                        {(isTeacher || isAdmin) && (
                            <>
                                {currentSection === 1 && <div className='gmCollectionUpr' style={{ marginTop: 15 }}>
                                    <div className='gmCollection'>
                                        <AdminStudy
                                            newMaskId={newMaskId}
                                            pageId={page}
                                            bookId={chapter}
                                            showDrawer={showDrawer}
                                            userId={currentUser?.id}
                                            oneStudyType={oneStudyType}
                                            onGameSelect={setActiveGame}
                                            gameInitLoader={gameInitLoader}
                                            setCurrentSection={setCurrentSection}
                                            gameDuplicateLoader={gameDuplicateLoader}
                                            startGame={(e) => {
                                                onStartGame(e)
                                            }}
                                            onDuplicateGame={(e) => {
                                                onGameDuplicate(e);
                                            }}
                                            backToLabelStory={backToLabelStory}
                                            resource={resource}
                                        />

                                    </div>
                                </div>}
                                {currentSection === 'my_game' && <div className='gmCollectionUpr' style={{ marginTop: 15 }}>
                                    <div className='gmCollection'>
                                        <MyStudy
                                            newMaskId={newMaskId}
                                            showDrawer={showDrawer}
                                            setCurrentSection={setCurrentSection}
                                            bookId={chapter}
                                            pageId={page}
                                            userId={currentUser?.id}
                                            onEditGame={(gameData) => {
                                                onGameEdit(gameData);

                                            }}
                                            onGameSelect={(val) => {
                                                setActiveGame(val)
                                            }}
                                            gameInitLoader={gameInitLoader}
                                            gameEditLoader={gameEditLoader}
                                            startGame={(e) => {
                                                onStartGame(e)

                                            }}
                                            oneStudyType={oneStudyType}
                                            backToLabelStory={backToLabelStory}
                                            resource={resource}
                                        />

                                    </div>
                                </div>}
                                {currentSection === 'draft_game' && <div className='gmCollectionUpr' style={{ marginTop: 15 }}>
                                    <div className='gmCollection'>
                                        <DraftStudy
                                            newMaskId={newMaskId}
                                            showDrawer={showDrawer}
                                            setCurrentSection={setCurrentSection}
                                            bookId={chapter}
                                            pageId={page}
                                            userId={currentUser?.id}
                                            onEditGame={(gameData) => {
                                                onGameEdit(gameData);

                                            }}
                                            onGameSelect={(val) => {
                                                setActiveGame(val)
                                            }}
                                            gameInitLoader={gameInitLoader}
                                            gameEditLoader={gameEditLoader}
                                            startGame={(e) => {
                                                onStartGame(e)

                                            }}
                                            oneStudyType={oneStudyType}
                                        />
                                    </div>
                                </div>}
                                {currentSection === 'all_teachers' && <div className='gmCollectionUpr' style={{ marginTop: 15 }}>
                                    <div className='gmCollection'>
                                        <AllTeachersStudy
                                            newMaskId={newMaskId}
                                            showDrawer={showDrawer}
                                            setCurrentSection={setCurrentSection}
                                            bookId={chapter}
                                            pageId={page}
                                            userId={currentUser?.id}
                                            gameInitLoader={gameInitLoader}
                                            startGame={(e) => {
                                                onStartGame(e)
                                            }}
                                            onDuplicateGame={(e) => {
                                                onGameDuplicate(e);
                                            }}
                                            gameDuplicateLoader={gameDuplicateLoader}
                                            oneStudyType={oneStudyType}
                                        />
                                    </div>
                                </div>}
                            </>
                        )}
                        {get(currentUser, "role") === "student" && (
                            <div className='gmCollectionUpr' style={{ marginTop: 15 }}>
                                <div className='gmCollection'>
                                    <StudentStudy
                                        newMaskId={newMaskId}
                                        showDrawer={showDrawer}
                                        setCurrentSection={setCurrentSection}
                                        bookId={chapter}
                                        pageId={page}
                                        userId={currentUser?.id}
                                        onEditGame={(gameData) => {
                                            onGameEdit(gameData);

                                        }}
                                        onGameSelect={(val) => {
                                            setActiveGame(val)
                                        }}
                                        gameInitLoader={gameInitLoader}
                                        gameEditLoader={gameEditLoader}
                                        startGame={(e) => {
                                            onStartGame(e)

                                        }}
                                        oneStudyType={oneStudyType}
                                        teacherId={get(currentClass, 'teacherId', '')}
                                    />

                                </div>
                            </div>
                        )}
                    </div>
                </ModalContentDelete>
            </ModalTest>

            
                    <ModalDrop
                        open={gameVisibleEbk}
                        onCancel={handleCancelEbk}
                        maskClosable={false}
                        className={`scenarioMdlWrap ${currentScenarioEbk >= 6 && currentScenarioEbk < 9 ? 'modalNextSix' : (currentScenarioEbk >= 3) ? 'gmScenarioSecond' : ''}`}
                    >
                        <div>
                            {currentScenarioEbk === 1 &&
                                <div className='aiGmMdl'>
                                    <div className="createStudyBackBtn" onClick={() => {
                                        setCurrentScenarioEbk(2);
                                    }}>
                                        <img src={DebateLftIcon} alt="Debate" />
                                    </div>
                                    <div className='aiMdlLbl'><label>Create your 1Study!</label> <AIUsageInfo /></div>
                                    <div className='aiGmMdlInr'>
                                        <div className='aiMdlOvr'><a onClick={() => handleRedirectOnegame("blank")}><span>{redirectLoader === "blank" ? <Loading size={18} /> : null} Blank template</span> <img src={studyBlankTemplate} alt="" /></a></div>
                                        <div className='aiMdlOvr'><a onClick={handleAIGenerateFromBookSection} style={{}} ><span><label> {redirectLoader === "ai_content" ? <Loading size={18} /> : null} AI Generator utilizing</label> this book section</span> <img src={AiGeneratedBook} alt="" /></a></div>
                                        <div className='aiMdlOvr'><a onClick={handleAIGenerateFromMyOwnTopics}><span><label> {redirectLoader === "ai" ? <Loading size={18} /> : null} AI Generator using</label> my own topics</span> <img src={AiGeneratedTopic} alt="" /></a></div>
                                    </div>
                                </div>
                            }
                            {currentScenarioEbk === 2 &&
                                <div className='aiGmMdl'>
                                    <div className='aiMdlLbl'><label>Choose your 1Study type!</label></div>
                                    <div className='aiGmMdlInr'>
                                        <div className='aiMdlOvr'><a onClick={() => { handleFlashcard('quiz') }} ><span> Quiz</span> <img src={CreateQuizIcon} alt="" /></a></div>
                                        <div className='aiMdlOvr'><a onClick={() => { handleFlashcard("flash_card") }}><span> Flashcards</span> <img src={CreateFlashCardIcon} alt="" /></a></div>
                                    </div>
                                </div>
                            }
                            {currentScenarioEbk === 3 && <div className='yourMagic'>
                                <div>
                                    <div className='yourMagicImg'><img src={IGameAI} alt="" /></div>
                                    <div className='yourMagicTxt' onClick={handleNextEbk}><p>Working on your magic!</p></div>
                                    <div className="maginSpinner">
                                        <Spin size="large" indicator={
                                            <div className="magicIndicator">
                                                <div className="dot" />
                                                <div className="dot" />
                                                <div className="dot" />
                                                <div className="dot" />
                                            </div>
                                        } />
                                    </div>
                                </div>
                            </div>
                            }
                            {currentScenarioEbk === 4 && <div className='writeTpcUpr'>
                                <div className="createBckBtn">
                                    <span className="arrowBckBtn"><ArrowBackIos /></span>AI Creator
                                </div>

                                <div className='writeTpcEbk writeTpcEbkSection'>
                                    <p>Your questions are ready for your selection!</p>
                                    <img src={IGameAI} alt="" />
                                </div>
                                <div className="generateMore">
                                    <div className="subGenerateMore">
                                        <p>El 14 de febrero, amor o mercadeo?</p>
                                        <Button>Generate more</Button>
                                    </div>
                                </div>
                                <div className='quesSelect'>
                                    <div className='quesSelectTxt'><p>Title: EI 14 de febrero, amor o mercadeo?</p></div>

                                    <div className='quesSelectTxt'>
                                        <Button onClick={handleButtonClick}
                                            className={selected ? 'greenButton' : 'defaultButton'}>{selected ? 'Selected' : 'Select'}
                                            {selected ? <RemoveCircle /> : <AddCircleSharp />}</Button>
                                        <p>1. Origen del Dia de san valentin:</p>
                                        <p>A. Roma Antigua</p>
                                        <p>B. Grecia Moderna <img src={IGameRightTick} alt="" /></p>
                                        <p>C. Egipto Antiguo</p>
                                        <p>D. Edad Media Europea</p>
                                    </div>
                                    <div className='quesSelectTxt'>
                                        <Button onClick={handleAddButtonClick}
                                            className={selectedAdd ? 'greenButton' : 'defaultButton'}>{selectedAdd ? 'Selected' : 'Select'}
                                            {selectedAdd ? <RemoveCircle /> : <AddCircleSharp />}</Button>
                                        <p>1. Origen del Dia de san valentin:</p>
                                        <p>A. Roma Antigua</p>
                                        <p>B. Grecia Moderna <img src={IGameRightTick} alt="" /></p>
                                        <p>C. Egipto Antiguo</p>
                                        <p>D. Edad Media Europea</p>
                                    </div>

                                    <div className='allCreateBtn'>
                                        <Button>Cancel</Button>
                                        <Button onClick={() => { setCurrentScenarioEbk(6) }}>Create and play now!</Button>
                                        <Button>Create to play later!</Button>
                                    </div>

                                </div>
                            </div>
                            }
                        </div>
                    </ModalDrop>
                

            <Drawer
                placement="right"
                closable={true}
                onClose={onClose}
                open={visible}
                width="100%"
                zIndex={9999}
                className='gameDevicemMain'
            >
                <Row className='gameOnDevice'>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                        <div className='gameDeviceLeft'>
                            <img src={IGameModalImgDeck} alt="" />
                        </div>
                    </Col>
                    <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                        <div className='gameDeviceRght'>
                            <div className='gameLogo'><img src={IGameLogo} alt="" /></div>
                        </div>
                    </Col>
                </Row>
            </Drawer>
            <ModalTest
                open={createConfigModal}
                onClose={onAIPagesClose}
                style={{ height: "100%", width: "100%" }}
            >
                <ModalContent style={{ width: "60vw", minHeight:"auto"  }}>
                    <Row style={{ justifyContent: "space-between" }}>
                        <IconButton
                            onClick={() => onAIPagesClose()}
                            style={{ padding: 0, marginRight: 10 }}
                        >
                            <Close color="secondary" />
                        </IconButton>
                    </Row>
                    <ModalConfigArea style={{ overflow:"visible" }}>
                        <FormControl variant="outlined" className={classes.formControl} style={{ marginTop: 12 }}>
                            <InputLabel id="pages-label">Select Pages (max 10)</InputLabel>
                            <Select
                                labelId="pages-label"
                                multiple
                                value={typeof config.pages === "string" ? config.pages.split(',').filter(p => p.trim() !== '').map(Number) : []}
                                onChange={(e) => {
                                    const selectedValues = e.target.value;
                                    const previousSelected = typeof config.pages === "string" ? config.pages.split(',').map(Number) : [];
                                    if (selectedValues.length > 10 && selectedValues.length > previousSelected.length) {
                                        showAlert("You can select a maximum of 10 pages.","warning");
                                        return;
                                    }
                                    const value = selectedValues.join(',');
                                    setConfig(k => ({ ...k, pages: value }));
                                    setError(null);
                                }}
                                input={<OutlinedInput label="Select Pages (max 10)" />}
                                renderValue={(selected) => (
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                      {selected.map((id) => {
                                        const match = pages.find(p => p.pageId == id);
                                        return <Chip key={id} label={match?.NumberMasked || id} />;
                                      })}
                                    </div>
                                  )}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page.pageId} value={parseInt(page.pageId)}>
                                        <RenderIfVisible defaultHeight={24} stayRendered={true} visibleOffset={500}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                <Checkbox
                                                    checked={typeof config.pages === "string" ? config.pages.split(',').filter(p => p.trim() !== '').includes(page.pageId?.toString?.()) : false}
                                                />
                                                <ListItemText primary={page.NumberMasked} />
                                            </div>
                                        </RenderIfVisible>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ModalConfigArea>
                    {error ? (
                        <CustomFormHelperText>
                            {error}
                        </CustomFormHelperText>
                    ) : null}
                    <Row
                        gutter={[24, 24]}
                        style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
                    >
                        <Button
                            fullWidth
                            onClick={() => {
                                onAiContentCreation();
                            }}
                            color="primary"
                            variant="contained"
                            disabled={createLoader || !(typeof config.pages === "string" && config.pages.split(',').filter(p => p.trim() !== '').length > 0)}
                            startIcon={createLoader ? <Loading white size={14} /> : null}
                        >
                            Generate
                        </Button>
                    </Row>
                </ModalContent>
            </ModalTest>
            <div className='vocOrGame' style={{ display: 'flex', alignItems: 'center', justifyContent: get(currentUser, "role") === "student" ? '' : 'center' }} ref={inputRef}>
                <button className='addOneImg'
                    onClick={() => {
                        if(checkPopUpAtOnce()) return;
                        if (handleForDistrictAdmin()) return;
                        showModal(isAdmin ? 'my_game' : 1);

                        setOneStudyType('all');
                         updatePopUpAtOnce(true);
                    }}
                >
                    <Badge
                    overlap="rectangular"
                    badgeContent={pageLearningModuleCountStudyAdmin?.length > 0 || pageLearningModuleCountStudy?.length > 0 ? "✓" : undefined}
                    color="success"
                    variant="standard"
                    sx={{width: '100%'}}
                >
                    <img src={OneStudyIcon} alt="One Study" title="One Study" />
                    </Badge>
                    </button>
                    
            </div>

            

        </SentryWrap>
    );
};

export default OnestudyModals;
